import GeneralLayout from "../../../layouts/General"
import { RASParagraphs } from "../../../app/utils/constants"
import clsx from "clsx"
import { rachmanAndSonsImgs } from "../../../app/utils/constants"
import { useEffect, useState } from "react"

const rachmanAndSons = () => {
  const mediaSm = window.matchMedia("(min-width: 640px)")
  const [imgsLoaded, setImgsLoaded] = useState(false)

  useEffect(() => {
    const loadImage = image => {
      return new Promise((resolve, reject) => {
        const loadImg = new Image()
        loadImg.src = image

        loadImg.onload = () =>
          setTimeout(() => {
            resolve(image)
          }, 500)

        loadImg.onerror = err => reject(err)
      })
    }

    Promise.all(rachmanAndSonsImgs.map(image => loadImage(image)))
      .then(() => setImgsLoaded(true))
      .catch(err => console.log("Failed to load images", err))
  }, [])

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <section className="relative overflow-hidden bg-[url('/src/assets/imgs/our-story/rachman-and-sons/section-cover.webp')] bg-cover bg-center lg:h-[1000px] bg-no-repeat">
          {!imgsLoaded && (
            <div className={clsx("h-full w-full absolute z-10", { "bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 transition-opacity animate-shimmer": !imgsLoaded })}></div>
          )}
          <div className={clsx("relative xs:w-[375px] sm:w-[640px] md:w-[768px] lg:w-[1024px] xl:w-[1280px] mx-auto transition-opacity", { "opacity-0": !imgsLoaded, "opacity-1": imgsLoaded })}>
            <div className="sm:left-5 md:left-[80px] lg:left-[160px] xl:left-[280px] relative top-4 md:top-16 lg:top-10 -rotate-3">
              <img src={rachmanAndSonsImgs[0]} width="100" loading="lazy" className="w-[200px] sm:w-[300px] md:w-[400px] lg:w-[420px] xl:w-[530px]" />
              {/* md:text-2xl */}
              <p className="absolute max-sm:w-[100px] left-1 sm:left-[70px] md:left-[140px] lg:left-[150px] xl:left-[140px] bottom-5 text-white font-aAccSign text-xs sm:text-sm xl:text-3xl tracking-wide -rotate-[10deg] font-thin">Jonathan, Ivan & Alain</p>
            </div>
            <img src={rachmanAndSonsImgs[1]} width="100" loading="lazy" className="max-xl:-rotate-[13deg] w-[200px] sm:w-[320px] md:w-[360px] lg:w-[510px] relative -top-4 sm:-top-8 md:-top-[130px] lg:-top-[200px] xl:-top-[580px] -left-8 md:-left-16 lg:-left-20 xl:-left-2" />
            <div className="absolute -right-16 sm:-right-20 md:-right-24 lg:-right-[80px] xl:-right-7 top-32 max-md:top-20 md:top-32 xl:top-20">
              <img src={mediaSm.matches ? rachmanAndSonsImgs[2] : rachmanAndSonsImgs[3]} width="100" loading="lazy" className="w-[388px] sm:w-[620px] md:w-[630px] lg:w-[700px] xl:w-[760px]" />
              <div className="absolute z-10 top-[65px] sm:top-[100px] md:top-[104px] lg:top-32 left-[85px] sm:left-[138px] md:left-[140px] lg:left-44">
                <h1 className="font-sloopScriptPro text-[#6e6059] text-xl sm:text-4xl md:text-5xl">Rachman & Sons</h1>
                <div className="sm:mt-3 md:mt-4 xl:mt-8 w-[225px] sm:w-[360px] md:w-[365px] lg:w-[370px] xl:w-[430px]">
                  {RASParagraphs.map((p, i) => (
                    <div key={i} className="font-americanTC text-[#6e6059] leading-[8px] sm:leading-3 xl:leading-[14px] text-[6.5px] sm:text-[10px] xl:text-xs mb-1 sm:mb-2 text-justify">{p}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

export default rachmanAndSons